import PropTypes from "prop-types";
import { useMemo } from "react";
import { ErrorMessage } from "../../../../components/error-message";
import { Select } from "../../../../components/select";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../../context/locale-provider";
import styles from "./styles";

export const DateOfBirthField = ({
  dateOfBirth,
  minDateOfBirth,
  onChange,
  validationErrors,
}) => {
  const translate = useTranslate(useLocaleProvider());

  const days = useMemo(() => {
    const days = [];
    for (let i = 1; i <= 31; i++) {
      const formattedDay = i < 10 ? `0${i}` : i.toString();
      days.push({
        value: formattedDay,
        description: formattedDay,
        disabled: false,
      });
    }
    return days;
  }, []);

  const years = useMemo(() => {
    const years = [];
    const minYear = new Date(minDateOfBirth).getFullYear();
    const endYear = minYear - 100;
    for (let i = minYear; i >= endYear; i--) {
      years.push({
        value: i.toString(),
        description: i.toString(),
        disabled: false,
      });
    }
    return years;
  }, []);

  return (
    <>
      <label htmlFor={styles.wrapper} className="app_london3">
        {translate("sv_form_dob_label")}:
      </label>
      <div id={styles.wrapper} className={styles.wrapper} role="group">
        <label htmlFor="dobDay" className="app_london3" hidden>
          {`${translate("sv_form_dob_label")} - ${translate(
            "sv_form_dob_day"
          )}:`}
        </label>
        <Select
          id="dobDay"
          className="dob_day"
          items={[
            {
              value: "",
              disabled: true,
              description: translate("sv_form_dob_day"),
            },
            ...days,
          ]}
          hasError={validationErrors.day}
          ariaLabel={`${translate("sv_form_dob_label")}: ${translate(
            "sv_form_dob_day"
          )}`}
          initialValue={dateOfBirth?.day}
          onItemClick={(e) => onChange({ ...dateOfBirth, day: e.target.value })}
        />
        <label htmlFor="dobMonth" className="app_london3" hidden>
          {`${translate("sv_form_dob_label")} - ${translate(
            "sv_form_dob_month"
          )}:`}
        </label>
        <Select
          id="dobMonth"
          className="dob_month"
          items={[
            {
              value: "",
              disabled: true,
              description: translate("sv_form_dob_month"),
            },
            { value: "01", description: "January" },
            { value: "02", description: "February" },
            { value: "03", description: "March" },
            { value: "04", description: "April" },
            { value: "05", description: "May" },
            { value: "06", description: "June" },
            { value: "07", description: "July" },
            { value: "08", description: "August" },
            { value: "09", description: "September" },
            { value: "10", description: "October" },
            { value: "11", description: "November" },
            { value: "12", description: "December" },
          ]}
          initialValue={dateOfBirth?.month}
          onItemClick={(e) =>
            onChange({ ...dateOfBirth, month: e.target.value })
          }
          ariaLabel={`${translate("sv_form_dob_label")}: ${translate(
            "sv_form_dob_month"
          )}`}
          hasError={validationErrors.month}
        />
        <label htmlFor="dobYear" className="app_london3" hidden>
          {`${translate("sv_form_dob_label")} - ${translate(
            "sv_form_dob_year"
          )}:`}
        </label>
        <Select
          id="dobYear"
          className="dob_year"
          items={[
            {
              value: "",
              disabled: true,
              description: translate("sv_form_dob_year"),
            },
            ...years,
          ]}
          ariaLabel={`${translate("sv_form_dob_label")}: ${translate(
            "sv_form_dob_year"
          )}`}
          initialValue={dateOfBirth?.year}
          onItemClick={(e) =>
            onChange({ ...dateOfBirth, year: e.target.value })
          }
          hasError={validationErrors.year}
        />
      </div>
      {(validationErrors.day ||
        validationErrors.month ||
        validationErrors.year) && (
        <ErrorMessage message={translate("sv_form_dob_error")} />
      )}
      {validationErrors.isAboveMinimumAge && (
        <ErrorMessage message={translate("sv_form_dob_age_error")} />
      )}
    </>
  );
};

DateOfBirthField.propTypes = {
  dateOfBirth: PropTypes.object.isRequired,
  minDateOfBirth: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
};
